import ComponentAsyncLoading from '@/components/loading/ComponentAsyncLoading';
import ComponentAsyncError from '@/components/loading/ComponentAsyncError';

export default path => () => ({
  component: import(`@/components/${path}.vue`),
  loading: ComponentAsyncLoading,
  error: ComponentAsyncError,
  delay: 0,
  timeout: 5000,
});
